import ptBrTranslations from './pt-br'
import enUsTranslations from './en'
import esUsTranslations from './es'
import chUsTranslations from './ch'

export default {
  'pt-BR': ptBrTranslations,
  en: enUsTranslations,
  es: esUsTranslations,
  ch: chUsTranslations
}
